import React, { useEffect, useState } from "react"
import { connect } from 'react-redux';
import { useSnackbar } from "notistack";
import purchasesInWorkService from "../../services/purchasesInWorkService";
import { PurchaseInWorkItem } from "./purchase-in-work-item";
import { SortingSelect } from "../sorting-select";
import { PageSizeSelect } from "../page-size-select";
import noContentImg from "../../img/icons/no-purchases.png"

import { Box, Stack, Pagination, CircularProgress, Grid, Typography } from '@mui/material';

const PurchaseInWorkList = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [sortingOptions, setSortingOptions] = useState([]);

    useEffect(() => {
        props.onLoadingPage(props, props.currentPage, enqueueSnackbar);
    }, [props.orderBy, props.pageSize, props.currentCompany]);

    useEffect(() => {
        purchasesInWorkService.getPurchaseInWorkSortingOptions()
            .then(setSortingOptions)
            .catch(() => {});
    }, []);

    const handlePaginationChange = (e, newPage) => {
        props.onLoadingPage(props, newPage, enqueueSnackbar);
    }

    return (
        <React.Fragment>
            {props.isLoading 
            ? 
                <CircularProgress />
            :
                <>
                {
                    props.purchasesInWork.length > 0
                    ?
                    <>
                        <Box sx={{ mb: 2 }} className='purchase_container_header invoices_container_header'>
                            <Grid container className='purchase_container_inner'>
                                <Grid item xs={3}>
                                    <Typography>Сортировать по:</Typography>
                                    <SortingSelect
                                        value={props.orderBy}
                                        onChange={props.onChangeSorting}
                                        options={sortingOptions}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography>Закупок на странице:</Typography>
                                    <PageSizeSelect
                                        value={props.pageSize}
                                        onChange={props.onChangePageSize}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className="purchase_container_items" sx={{ width: '100%' }}>
                        {
                            props.purchasesInWork.map((purchase, key) => 
                                <PurchaseInWorkItem purchaseInWork={purchase} key={key} />
                            )
                        }
                        </Box>
                        <Box sx={{ mt: 2 }}>
                            <Stack spacing={2}>
                                <Pagination page={props.currentPage} count={props.pagesCount} onChange={handlePaginationChange} />
                            </Stack>
                        </Box>
                    </>
                    :
                    <Box className="no_item_block">
                        <Box className="no_item_block_icon">
                            <img src={noContentImg} alt=""/>
                        </Box>
                        <Box className="no_item_block_text_main" sx={{mt:3}}>
                            Упс... кажется закупки в работе отсутствуют.
                        </Box>
                        <Box className="no_item_block_text_second">
                            При заключении с нами договора вы сможете выбирать и добавлять закупки в совместную работу.
                            <br/>
                            Закупки в работе будут отображаться в этом разделе.
                        </Box>
                    </Box>
                }
                </>
            }
		</React.Fragment>
    )
}

function mapStateToProps(state) {
    return {
        currentPage: state.purchasesInWorkState.currentPage,
        pagesCount: state.purchasesInWorkState.pagesCount,
        pageSize: state.purchasesInWorkState.pageSize,
        orderBy: state.purchasesInWorkState.orderBy,
        purchasesInWork: state.purchasesInWorkState.purchasesInWork,
        isLoading: state.purchasesInWorkState.isLoading,
        currentCompany: state.profileState.currentCompany
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onLoadingPage: (state, pageNumber, enqueueSnackbar) => {
            const pageAction = {
                type: 'CURRENT_PAGE_CHANGED',
                currentPage: 'purchases-in-work'
            };
            dispatch(pageAction);
            if (state.currentCompany) {
                const action = {
                    type: 'PURCHASE_IN_WORK_LOAD_STARTED'
                };
                dispatch(action);
                if (state.currentCompany.Id) {
                    purchasesInWorkService.getPurchasesInWork(pageNumber, state.pageSize, state.orderBy, state.currentCompany.Id)
                        .then((result) => {
                            const action = {
                                type: 'PURCHASE_IN_WORK_PAGE_LOADED', 
                                pagesCount: result.TotalPages,
                                currentPage: result.PageNumber,
                                purchasesInWork: result.Items
                            };
                            dispatch(action);
                        })
                        .catch((error) => {
                            enqueueSnackbar(`Произошла ошибка. ${error.Message ? error.Message : ''}`, { variant: "error" });
                            const action = {
                                type: 'PURCHASE_IN_WORK_LOAD_ERROR'
                            };
                            dispatch(action);
                        });
                } else {
                    const action = {
                        type: 'PURCHASE_IN_WORK_PAGE_LOADED', 
                        pagesCount: 1,
                        currentPage: 0,
                        purchasesInWork: []
                    };
                    dispatch(action);
                }
            }
        },
        onChangeSorting: (value) => {
            const action = {
                type: 'PURCHASE_IN_WORK_SORTING_CHANGED',
                value: value
            };
            dispatch(action);
        },
        onChangePageSize: (value) => {
            const action = {
                type: 'PURCHASE_IN_WORK_PAGE_SIZE_CHANGED',
                value: value
            };
            dispatch(action);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseInWorkList)
